module.exports = __webpack_public_path__ + "static/media/provider_quickspin.b737d3dd.jpg";